import WktFormat from 'ol/format/WKT'
import Vue from 'vue'
import getPixels from 'get-pixels'
import { parallel, map, mapSeries } from 'async'
import mergeImages from 'merge-images'
import store from '../store'

const wkt = new WktFormat()

class PotreeService {
  constructor (options) {
    console.log('CREATING POTREE PLUGIN')
    this.viewer = options.viewer
    this.workpackId = options.workpackId || 12007

    this.textureContainer = {}
    this.tilePlaceholders = {}
    this.pendingTiles = []
    this.loadingTiles = {}

    this.wmsLayers = [
      {
        name: 'v4:centreline',
        cql: `workpack_id=${this.workpackId}`,
        tileType: 'terrain',
        enabled: true
      },
      {
        name: 'v4:well',
        cql: `workpack_id=${this.workpackId}`,
        tileType: 'terrain',
        enabled: true
      },
      {
        name: 'v4:well_drainage',
        cql: `workpack_id=${this.workpackId}`,
        tileType: 'subsurface',
        enabled: true
      }
    ]

    this.vectorLayers = [
      {
        name: 'well_drillstrings',
        workpack_id: this.workpackId,
        color: 0x00FF00,
        type: 'line',
        enabled: true
      }
      // BELOW CAUSING ERROR NOT FINDING DB TABLE
      // {
      //   name: 'provided_drillstrings',
      //   workpack_id: 1,
      //   color: 0xCC33FF,
      //   type: 'line',
      //   enabled: true
      // }
    ]
    this.drawTerrain = false
    this.drawSubsurface = false

    this.srs = options.srs

  }

  createBasePlane () {
    console.log('CREATING BASE PLANE')

    this.PLANE_MINX = 189586.6272
    this.PLANE_MINY = 5812134.5296
    this.PLANE_WIDTH = 620826.7456
    this.PLANE_HEIGHT = 1785237.0198

    console.log(this.srs)
    if (this.srs === 'EPSG:28355') {
      this.PLANE_MINX = 175479.2570
      this.PLANE_MINY = 5112643.4740
      this.PLANE_WIDTH = 649041.486
      this.PLANE_HEIGHT = 3370794.8139000004
    }

    this.MAX_Z = 1200000
    this.BASE_Z = -1000
    this.tilesBuffer = []
    this.currentZoom = -1
    this.terrainTileSize = 128
    this.imageryTileSize = 512
    this.seams = {}

    this.registerWorkers()
    this.calcSeams()

    let geometry = new THREE.PlaneGeometry(this.PLANE_WIDTH, this.PLANE_HEIGHT, 1)
    let material = new THREE.MeshBasicMaterial({color: 0xff0000, wireframe: true, opacity: 1})

    let plane = new THREE.Mesh(geometry, material)
    plane.geometry.vertices.forEach((v) => {
      v.x = v.x + (this.PLANE_WIDTH / 2) + this.PLANE_MINX
      v.y = v.y + (this.PLANE_HEIGHT / 2) + this.PLANE_MINY
      v.z = this.BASE_Z
    })
    plane.name = 'base_plane'
    this.plane = plane
    this.viewer.scene.scene.add(plane)
    this.viewer.scene.planeBase = plane

    // console.log(this.viewer.earthControls)
    this.viewer.earthControls.addEventListener('end', (e) => {
      if (e.action === 'scroll') {
        let zoom = Math.floor(this.getZoom())
        if (zoom !== this.currentZoom) {
          this.currentZoom = zoom
          this.updateTiles()
        }
      } else {
        this.updateTiles()
      }


      this.updateCompass()
      // console.log(this.getCurrentFrustrum())
    })

    this.viewer.earthControls.addEventListener('drag', () => {
      this.updateCompass()
    })

    setTimeout(() => {
      this.updateTiles()
      this.updateCompass()

    }, 4000)

    this.flag = 0
  }

  updateCompass () {
    let pos = this.getCentralPoint()
    if (pos) {
      let camera = this.viewer.scene.getActiveCamera()
      store.commit('map/angle3d', PotreeService.findAzimuth(pos, camera.position))
      store.commit('map/camera3dPotistion', [camera.position.x, camera.position.y].join(','))
    }
  }

  static findAzimuth (pt1, pt2) {
    let dX = pt2.x - pt1.x
    let dY = pt2.y - pt1.y
    let dist = Math.sqrt((dX * dX) + (dY * dY))
    let dXa = Math.abs(dX)
    let beta = (Math.acos(dXa / dist) * 180) / Math.PI

    let angle = 0

    if (dX > 0) {
      if (dY < 0) {
        angle = 270 + beta
      } else {
        angle = 270 - beta
      }
    } else {
      if (dY < 0) {
        angle = 90 - beta
      } else {
        angle = 90 + beta
      }
    }

    return angle
  }

  registerWorkers () {
    this.poolSize = 4
    this.workerPool = []
    for (let i = 0; i < this.poolSize; i++) {
      let worker = new Worker('/static/js/workers/terrainparser.js')
      this.workerPool.push(worker)

      worker.addEventListener('message', (e) => {

        e = e.data
        let terrainData = e[0]
        let tileSize = e[1]
        let t = e[2]
        let tileType = e[3]
        let s = this.terrainTileSize

        let texture = this.textureContainer[t.id]
        if (!texture) {
          return
        }

        this.viewer.scene.scene.remove(this.viewer.scene.scene.getObjectByName(t.id + 'p'))
        let index = this.tilesBuffer.map(function (tt) {return tt.id}).indexOf(t.id)
        if (index === -1) {
          return
        }

        this.resolveSeams(terrainData, t, tileType)

        /*let url = '/api/gs-lidar/wms?VERSION=1.1.1&FORMAT=image/png&REQUEST=GetMap&SRS=EPSG:28356&WIDTH=512&HEIGHT=512&TRANSPARENT=true' +
          '&BBOX=' + ([t.x, t.y, t.x + tileSize, t.y + tileSize].join(',')) + '&LAYERS=grp_imagery&tiled=true'

        // url = '/static/empty_tile.png'
        let texture = new THREE.TextureLoader()
          .load(url)*/

        let material = this.createMaterial(texture, tileType)
        this.loadAllCoverage(texture, tileType)

        let geometry = new THREE.PlaneBufferGeometry(tileSize, tileSize, s - 1, s - 1)
        geometry.addAttribute('position', new THREE.BufferAttribute(terrainData, 3))
        let plane = new THREE.Mesh(geometry, material)
        plane.name = tileType === 'terrain' ? (t.id + 't') : (t.id + 's')

        this.viewer.scene.scene.children.forEach(c => {
          if (c.name === plane.name) {
            this.viewer.scene.scene.remove(c)
          }
          /*if (c.name && (c.name[c.name.length-1] === 's' || c.name[c.name.length-1] === 't')) {
            let id = parseInt(c.name.slice(0, c.name.length-1))
            if (!isNaN(id) && (this.tilesBuffer.map(function (tt) {return tt.id}).indexOf(id) === -1)) {
              this.viewer.scene.scene.remove(c)
            }
          }*/
        })

        this.viewer.scene.scene.add(plane)

      })

    }
  }

  calcSeams () {
    let totalCount = Math.pow(this.terrainTileSize, 2) * 3
    let rowCount = this.terrainTileSize * 3
    //above, left, below, right
    this.seams['neighborTiles'] = [[0, 1, 0], [-1, 0, 0], [0, -1, 0], [1, 0, 0]]
    this.seams['row'] = [[], [], [], []]
    this.seams['rowZ'] = [[], [], [], []]

    for (let c = 0; c < rowCount; c += 3) {
      //top, left, bottom, right
      this.seams['row'][0].push(c + 1)
      this.seams['row'][1].push(c / 3 * (rowCount))
      this.seams['row'][2].push(c + 1 + totalCount - rowCount)
      this.seams['row'][3].push((c / 3 + 1) * (rowCount) - 3)

      this.seams['rowZ'][0].push(c + 2)
      this.seams['rowZ'][1].push(c / 3 * (rowCount) + 2)
      this.seams['rowZ'][2].push(c + 2 + totalCount - rowCount)
      this.seams['rowZ'][3].push((c / 3 + 1) * (rowCount) - 1)
    }
  }

  resolveSeams (data, t, tileType) {
    this.seams['neighborTiles'].forEach((nt, index) => {
      let [x, y, z] = this.fromID(t.id)
      x += nt[0]
      y += nt[1]

      let id = this.toID(x, y, z)

      let name = tileType === 'terrain' ? (id + 't') : (id + 's')
      let neighbour = this.viewer.scene.scene.getObjectByName(name)
      if (neighbour) {
        let neighbourIndex = (index + 2) % 4
        // indices that need to be overwritten
        let indicesToChange = this.seams['row'][index]
        //indices of neighbor vertices to copy
        let neighborIndices = this.seams['row'][neighbourIndex]
        let neighborVertices = neighbour.geometry.attributes.position.array

        let z = this.seams['rowZ'][index]
        let zn = this.seams['rowZ'][neighbourIndex]

        for (let a = 0; a < 128; a++) {
          data[indicesToChange[a]] = neighborVertices[neighborIndices[a]]
          data[z[a]] = neighborVertices[zn[a]]
        }
      }
    })

    return data
  }

  getDistanceToBasePlane () {
    let pos = this.getCentralPoint()
    let camera = this.viewer.scene.getActiveCamera()
    return camera.position.distanceTo(pos)
  }

  getZoom () {
    // let pt = this.viewer.scene.getActiveCamera().position.z
    let pt = this.getDistanceToBasePlane()
    return Math.max(
      this.getBaseLog(0.5, pt / this.MAX_Z),
      0
    )
  }

  getBaseLog (base, result) {
    return Math.log(result) / Math.log(base)
  }

  getCentralPoint () {
    let raycaster = new THREE.Raycaster()
    let camera = this.viewer.scene.getActiveCamera()
    raycaster.set(camera.getWorldPosition(), camera.getWorldDirection())
    let o = raycaster.intersectObject(this.plane)[0]
    if (!o) {
      return null
    } else {
      return o.point
    }
  }

  updateTiles () {
    let cp = this.getCentralPoint()
    if (!cp) {
      console.log('no objects under ray')
      return
    }

    let zoom = Math.floor(this.getZoom())
    // console.log('zoom: ' + zoom)
    // console.log('z: ' + (this.viewer.scene.getActiveCamera().position.z))
    if (zoom >= 18) {
      return
    }

    let tileSize = this.PLANE_WIDTH / Math.pow(2, zoom)
    console.log('tile size: ' + tileSize)
    if (isNaN(tileSize)) {
      return
    }

    let tiles = this.findTiles(cp, tileSize, zoom, 6)

    this.clearPlaceholders()
    tiles.forEach((t) => {
      t.tileSize = tileSize
      this.makeTilePlaceholder(t, tileSize)
    })

    let visibleTiles = this.getVisiblePlaceholders()
    tiles = tiles.filter(t => visibleTiles.indexOf(t.id) > -1)
    // this.clearPlaceholders()

    console.log(tiles.length)

    let newTiles = []
    let oldTiles = []

    tiles.forEach((t) => {
      let index = this.tilesBuffer.map(function (tt) {return tt.id}).indexOf(t.id)
      if (index === -1) {
        newTiles.push(t)
      }
      /*else {
             if (!this.viewer.scene.scene.getObjectByName(t.id + 's')  && !this.loadingTiles[t.id]) {
               this.tilesBuffer.splice(index, 1)
               newTiles.push(t)
             }
           }*/
    })

    this.tilesBuffer.forEach((t) => {
      let index = tiles.map(function (tt) {return tt.id}).indexOf(t.id)
      if (index === -1) {
        oldTiles.push(t)
      }
    })

    oldTiles.forEach((t) => {
      this.viewer.scene.scene.remove(this.viewer.scene.scene.getObjectByName(t.id + 't'))
      this.viewer.scene.scene.remove(this.viewer.scene.scene.getObjectByName(t.id + 's'))
      delete this.textureContainer[t.id]
      let index = this.tilesBuffer.map(function (tt) {return tt.id}).indexOf(t.id)
      this.tilesBuffer.splice(index, 1)
    })

    // console.log(`new: ${newTiles.length}`)
    // console.log(`old: ${oldTiles.length}`)

    let i = 0
    this.pendingTiles = []
    newTiles.forEach((t) => {
      this.tilesBuffer.push(t)
      let worker = this.workerPool[i++]
      if (i > (this.poolSize - 1)) {
        i = 0
      }
      this.pendingTiles.push({
        tile: t,
        worker: worker
      })

    })

    let uniMap = {}
    store.commit('map/loadingTiles', this.pendingTiles.length)
    this.pendingTiles.forEach(p => {
      uniMap[p.tile.id] = p
    })

    this.pendingTiles = []
    Object.keys(uniMap).forEach(k => {
      this.pendingTiles.push(uniMap[k])
    })

    this.loadTiles(0, 2)

    this.clearLostTrash()
  }

  clearLostTrash () {
    this.viewer.scene.scene.children.forEach(c => {
      let name = c.name
      if (name) {
        let n = name
        if (name[name.length - 1] === 's' || name[name.length - 1] === 't') {
          n = name.substr(0, name.length - 1)
        }
        n = parseInt(n)
        if (isNaN(n)) {
          return
        }
        let index = this.tilesBuffer.map(function (tt) {return tt.id}).indexOf(n)
        if (index === -1) {
          this.viewer.scene.scene.remove(c)
        }
      }
    })
  }

  loadTiles (index, step) {
    let tiles = this.pendingTiles.slice(index, index + step)
    store.commit('map/loadingTiles', tiles.length)
    if (!tiles.length) {
      return
    }
    map(tiles, (b, c) => {
      this.tile2mesh(b.tile, b.worker, c)
    }, () => {
      // store.commit('map/reduceLoadingTiles', 1)
      this.loadTiles(index + step, step * 2)
    })
  }

  tile2mesh (t, worker, clb) {
    let tileSize = t.tileSize
    let index = this.tilesBuffer.map(function (tt) {return tt.id}).indexOf(t.id)
    if (index === -1) {
      return
    }
    let url = '/api/gs-lidar/wms?VERSION=1.1.1&FORMAT=image/png&REQUEST=GetMap&SRS=EPSG:28356&WIDTH=128&HEIGHT=128&TRANSPARENT=true' +
      '&BBOX=' + ([t.x, t.y, t.x + tileSize, t.y + tileSize].join(',')) + '&LAYERS=wksp_arrow:sb_dem&tiled=true'

    let coalUrl = '/api/gs-lidar/wms?VERSION=1.1.1&FORMAT=image/png&REQUEST=GetMap&SRS=EPSG:28356&WIDTH=128&HEIGHT=128&TRANSPARENT=true' +
      '&BBOX=' + ([t.x, t.y, t.x + tileSize, t.y + tileSize].join(',')) + '&LAYERS=wksp_arrow:coaldepth_south_absolute_int16_56&tiled=true'

    let tUrl = '/api/gs-lidar/wms?VERSION=1.1.1&FORMAT=image/png&REQUEST=GetMap&SRS=EPSG:28356&WIDTH=512&HEIGHT=512&TRANSPARENT=true' +
      '&BBOX=' + ([t.x, t.y, t.x + tileSize, t.y + tileSize].join(',')) + '&LAYERS=grp_imagery&tiled=true'

    // url = '/static/empty_tile.png'
    this.loadingTiles[t.id] = t
    parallel([
      (clb) => {
        this.textureContainer[t.id] = {
          imageryTexture: null,
          urls: [],
          t: t
        }
        if (this.drawTerrain) {
          let imageryTexture = new THREE.TextureLoader()
            .load(tUrl, (err, resp) => {
              clb(null)
            })
          this.textureContainer[t.id] = {
            imageryTexture: imageryTexture,
            urls: [tUrl],
            t: t
          }
          this.textureContainer[t.id].imageryTexture = imageryTexture
          this.textureContainer[t.id].urls.push(tUrl)
        } else {
          clb(null)
        }

      },
      (clb) => {
        if (this.drawTerrain) {
          getPixels(url, (err, pixels) => {
            clb(null, pixels)
          })
        } else {
          clb(null)
        }

      }/*,
      (clb) => {
        getPixels(coalUrl, (err, pixels) => {
          clb(null, pixels)
        })
      }*/
    ], (err, res) => {
      if (!err) {
        if (this.drawTerrain) {
          worker.postMessage([res[1], t, tileSize, this.terrainTileSize, 'terrain'])
        }

        if (this.drawSubsurface) {
          worker.postMessage([null, t, tileSize, this.terrainTileSize, 'subsurface'])
        }

      } else {
        console.error('could not load tile')
      }
      delete this.loadingTiles[t.id]
      store.commit('map/reduceLoadingTiles', 1)
      clb(null)
    })

    // console.log('GET TEST')
    // getPixels('http://local.vd.com:8888/api/gs-lidar/wms?VERSION=1.1.1&FORMAT=image/png&REQUEST=GetMap&SRS=EPSG:28356&WIDTH=128&HEIGHT=128&TRANSPARENT=true&BBOX=276890.3883,7014986.3492,286590.8062,7024686.7671&LAYERS=wksp_arrow:sb_dem&t=kjhhjhjk',
    //   (err, pixels) => {
    //   console.log(pixels.data[0])
    //   console.log(pixels.data[1])
    //   console.log(pixels.data[2])
    //
    //   console.log(pixels.data[65536-384])
    //   console.log(pixels.data[65536-383])
    //   console.log(pixels.data[65536-382])
    //   })

  }

  createMaterial (tContainer, tileType) {
    /*if (!tContainer.imageryTexture) {
      return new THREE.MeshBasicMaterial({color: 0xffffff, wireframe: false, opacity: 1, transparent: false})
    }*/
    if (tileType === 'terrain') {
      return new THREE.MeshBasicMaterial({map: tContainer.imageryTexture, opacity: 0.65, transparent: true})
    } else {
      let texture = new THREE.TextureLoader()
        .load('/static/empty_tile.png')
      // return new THREE.MeshBasicMaterial({map: texture, opacity: 0.65, transparent: true})
      return new THREE.MeshBasicMaterial({map: texture})
      // return new THREE.MeshBasicMaterial({color: 0xffffff, wireframe: false, opacity: 0, transparent: true})
    }

  }

  getWmsCoverages (t, tileType) {
    return this.wmsLayers.filter(l => l.enabled).filter(l => l.tileType === tileType).map(layer => {
      return `/api/gs/wms?VERSION=1.1.1&FORMAT=image/png&REQUEST=GetMap&SRS=EPSG:28356&WIDTH=${this.imageryTileSize}&HEIGHT=${this.imageryTileSize}&TRANSPARENT=true&BBOX=${[t.x, t.y, t.x + t.tileSize, t.y + t.tileSize].join(',')}&LAYERS=${layer.name}${layer.cql ? '&cql_filter=' + layer.cql : ''}`
    })
  }

  loadAllCoverage (tContainer, tileType) {

    let urls = tContainer.urls.concat(this.getWmsCoverages(tContainer.t, tileType))
    let meshId = tContainer.t.id + 't'
    if (tileType === 'subsurface') {
      urls = this.getWmsCoverages(tContainer.t, tileType)
      meshId = tContainer.t.id + 's'
    }

    mergeImages(urls).then(b64 => {
      let texture = new THREE.TextureLoader()
        .load(b64, () => {
          let mesh = this.viewer.scene.scene.getObjectByName(meshId)

          if (mesh) {
            mesh.material.map = texture
            mesh.material.needsUpdate = true
          }
        })

    })
  }

  clearPlaceholders () {
    Object.keys(this.tilePlaceholders).forEach(k => {
      this.viewer.scene.scene.remove(this.viewer.scene.scene.getObjectByName(k + 'p'))
    })

    this.tilePlaceholder = {}
  }

  getVisiblePlaceholders () {
    let frustum = this.getCurrentFrustrum()
    return Object.keys(this.tilePlaceholders).filter(k => {
      return frustum.intersectsObject(this.tilePlaceholders[k])
    }).map(tid => parseInt(tid))
  }

  makeTilePlaceholder (t, tileSize) {
    let c = [
      t.x, t.y + tileSize, this.BASE_Z,
      t.x + tileSize / 2, t.y + tileSize, this.BASE_Z,
      t.x + tileSize, t.y + tileSize, this.BASE_Z,

      t.x, t.y + tileSize / 2, this.BASE_Z,
      t.x + tileSize / 2, t.y + tileSize / 2, this.BASE_Z,
      t.x + tileSize, t.y + tileSize / 2, this.BASE_Z,

      t.x, t.y, this.BASE_Z,
      t.x + tileSize / 2, t.y, this.BASE_Z,
      t.x + tileSize, t.y, this.BASE_Z

    ]
    let geometry = new THREE.PlaneBufferGeometry(tileSize, tileSize, 2, 2)
    geometry.addAttribute('position', new THREE.BufferAttribute(new Float32Array(c), 3))
    // let texture = new THREE.TextureLoader()
    //   .load('/static/empty_tile.png')
    // let plane = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({map: texture}))
    let plane = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
      color: 0xffffff,
      wireframe: false,
      opacity: 0,
      transparent: true
    }))

    plane.name = t.id + 'p'
    this.tilePlaceholders[t.id] = plane
    this.viewer.scene.scene.add(plane)
  }

  getCurrentFrustrum () {
    let frustum = new THREE.Frustum()
    let camera = this.viewer.scene.getActiveCamera()
    frustum.setFromMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse))

    return frustum
  }

  pointToTile (p, tileSize, zoom) {
    if (p.x < this.PLANE_MINX || p.y < this.PLANE_MINY || p.x > (this.PLANE_WIDTH + this.PLANE_MINX) || p.y > (this.PLANE_MINY + this.PLANE_HEIGHT)) {
      return null
    }

    let xc = Math.floor((p.x - this.PLANE_MINX) / tileSize)
    let yc = Math.floor((p.y - this.PLANE_MINY) / tileSize)

    //lower left angle
    let x = xc * tileSize + this.PLANE_MINX
    let y = yc * tileSize + this.PLANE_MINY

    // console.log(`ts: ${tileSize}, x: ${x}, y: ${y}`)
    // console.log(`xc: ${xc}, yc: ${yc}`)
    return {
      x: x,
      y: y,
      z: 0,
      id: this.toID(xc, yc, zoom)
    }
  }

  findTiles (p, tileSize, zoom, pad) {
    // let centralTile = pointToTile(p, tileSize, zoom)
    let tiles = []
    let stride = tileSize * pad
    let x = p.x - (stride / 2)
    let y = p.y - (stride / 2)
    let startY = y
    let maxX = x + stride
    let maxY = y + stride

    while (x < Math.floor(maxX)) {
      while (y < Math.floor(maxY)) {
        tiles.push(this.pointToTile({x: x, y: y}, tileSize, zoom))
        y += tileSize
      }
      x += tileSize
      y = startY
    }

    tiles = tiles.filter((t) => {
      return !!t
    })

    return tiles.sort((a, b) => {
      return this.dist(a, p) - this.dist(b, p)
    })
  }

  dist (a, b) {
    return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2)
  }

  toID (x, y, z) {
    let dim = 2 * (1 << z)
    return ((dim * y + x) * 32) + z
  }

  fromID (id) {
    var z = id % 32,
      dim = 2 * (1 << z),
      xy = ((id - z) / 32),
      x = xy % dim,
      y = ((xy - x) / dim) % dim
    return [x, y, z]
  }

  getRenderAreaBBOX () {

    let raycaster = new THREE.Raycaster()
    raycaster.setFromCamera({x: -1, y: -1}, this.viewer.scene.getActiveCamera())
    let intersect = raycaster.intersectObject(this.plane)[0]

    let minX = intersect ? intersect.point.x : null
    let minY = intersect ? intersect.point.y : null

    raycaster = new THREE.Raycaster()
    raycaster.setFromCamera({x: 1, y: 1}, this.viewer.scene.getActiveCamera())
    intersect = raycaster.intersectObject(this.plane)[0]

    let maxX = intersect ? intersect.point.x : null
    let maxY = intersect ? intersect.point.y : null

    return {
      minX: minX,
      minY: minY,
      maxX: maxX,
      maxY: maxY
    }

    // var geometry = new THREE.SphereGeometry( 500, 32, 32 )
    // geometry.translate(pt.x, pt.y, 50)
    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00} );
    // var sphere = new THREE.Mesh( geometry, material );
    // this.viewer.scene.scene.add(sphere)
  }

  /*createTubeLayer (layerName, workpack_id, color, radius, callback) {
    this.vectorLayers.push({
      layer_name: layerName
    })
    console.log(this.vectorLayers)
    Vue.http.get('/api/layers/data-3d-sample/', {
      params: {
        layer_name: layerName,
        workpack_id: workpack_id,
        geom_type: 'tube',
      }
    })
      .then(res => {
        let pathMap = {}

        res.body.forEach(c => {
          if (!pathMap[c.id]) {
            pathMap[c.id] = []
          }
          pathMap[c.id].push(c)
        })

        for (let k in pathMap) {
          if (pathMap.hasOwnProperty(k)) {
            let curve = this.getCurveTube()
            let lineLength = pathMap[k][0].length
            let path = []
            curve.setCoords(pathMap[k].map((c) => {
              // path.push(c.x)
              // path.push(c.y)
              // path.push(c.z)
              return {
                vec: new THREE.Vector3(c.x, c.y, c.z),
                location: c.location,
                length: c.length
              }
            }))

            // let p1 = curve.getPoint(0.1)
            // let p2 = curve.getPoint(0.3)
            //
            // console.log(`POINT(${p1.x} ${p1.y})`)
            // console.log(`POINT(${p2.x} ${p2.y})`)
            // break

            /!*let geometry = new THREE.BufferGeometry()
            let material = new THREE.LineBasicMaterial({color: 0xff0000, linewidth: 4})
            let buffer = new Float32Array(path)
            geometry.addAttribute('position', new THREE.BufferAttribute(buffer, 3))
            geometry.computeBoundingSphere()
            let line = new THREE.Line(geometry, material)
            this.viewer.scene.scene.add(line)*!/

            let geometry = new THREE.TubeGeometry(curve, parseInt(lineLength / 5), radius, 8, false)
            let material = new THREE.MeshBasicMaterial({color: color, opacity: 0.4})
            material.transparent = true
            material.opacity = 0.4
            let mesh = new THREE.Mesh(geometry, material)
            mesh.name='vector_'+layerName
            this.viewer.scene.scene.add(mesh)
          }
        }

      }, res => {})
  }*/

  createLineLayer (layerName, workpack_id, color, callback, seamIdent) {
    Vue.http.get('/api/layers/data-3d-sample/', {
      params: {
        layer_name: layerName,
        workpack_id: workpack_id,
        geom_type: 'tube',
        seam_ident: seamIdent
      }
    })
      .then(res => {
        let pathMap = {}

        res.body.forEach(c => {
          if (!pathMap[c.id]) {
            pathMap[c.id] = []
          }
          pathMap[c.id].push(c)
        })

        let group = new THREE.Group()
        group.name = layerName + '_vector'

        for (let k in pathMap) {
          if (pathMap.hasOwnProperty(k)) {
            // let curve = this.getCurveTube()
            // let lineLength = pathMap[k][0].length
            let path = []
            pathMap[k].map((c) => {
              path.push(c.x)
              path.push(c.y)
              path.push(c.z)

            })

            let geometry = new THREE.BufferGeometry()
            let material = new THREE.LineBasicMaterial({color: color, linewidth: 4})
            let buffer = new Float32Array(path)
            geometry.addAttribute('position', new THREE.BufferAttribute(buffer, 3))
            geometry.computeBoundingSphere()
            let line = new THREE.Line(geometry, material)
            group.add(line)
          }
        }
        this.viewer.scene.scene.add(group)
        console.log(group)

      }, res => {})
  }

  createSeamPointLayer(seamName, color) {
    Vue.http.get('/api/layers/seam-layer-points/', {
      params: {
        seam_name: seamName,
      }
    }).then(res => {
      let points = res.body
      let starsGeometry = new THREE.Geometry();
      for ( let i = 0; i < points.length; i ++ ) {

        let star = new THREE.Vector3();
        star.x = points[i][0];
        star.y = points[i][1];
        star.z = points[i][2];

        starsGeometry.vertices.push( star );

      }

      let starsMaterial = new THREE.PointsMaterial( { color: color } );

      let starField = new THREE.Points( starsGeometry, starsMaterial );

      this.viewer.scene.scene.add( starField );
    }, e => {
      console.error(e)
    })
  }

  getCurveTube () {
    // if (this.curveTube) {
    //   return this.curveTube
    // }
    function CustomLineCurve (scale) {

      THREE.Curve.call(this)

      this.scale = (scale === undefined) ? 1 : scale

    }

    CustomLineCurve.prototype = Object.create(THREE.Curve.prototype)
    CustomLineCurve.prototype.constructor = CustomLineCurve
    CustomLineCurve.prototype.setCoords = function (coords) {
      this.coords = coords
    }

    CustomLineCurve.prototype.getPoint = function (t) {
      let coord
      let nextCoord
      let delta
      let i = 0
      if (t === 0) {
        return this.coords[0].vec
      }
      for (; i < (this.coords.length - 1); i++) {
        // console.log(`${this.coords[i].location} -> ${this.coords[i + 1].location} : ${t}`)
        if (this.coords[i].location < t && t < this.coords[i + 1].location) {
          coord = this.coords[i]
          nextCoord = this.coords[i + 1]
          delta = Math.abs(t - coord.location)
          break
        }
      }
      if (!coord) {
        return this.coords[this.coords.length - 1].vec
      }

      // console.log(`POINT(${coord.vec.x} ${coord.vec.y})`)
      // console.log(`POINT(${nextCoord.vec.x} ${nextCoord.vec.y})`)

      let nc = new THREE.Vector3(
        nextCoord.vec.x - coord.vec.x,
        nextCoord.vec.y - coord.vec.y,
        nextCoord.vec.z - coord.vec.z
      )
      nc.normalize()
      return new THREE.Vector3(
        coord.vec.x + (nc.x * delta * coord.length),
        coord.vec.y + (nc.y * delta * coord.length),
        coord.vec.z + (nc.z * delta * coord.length)
      )
    }

    return new CustomLineCurve()
    // this.curveTube = CustomLineCurve
    // return this.curveTube
  }

  createPointLayer (layerName, workpack_id, color, size, callback) {
    Vue.http.get('/api/layers/data-3d-sample/', {
      params: {
        layer_name: layerName,
        workpack_id: workpack_id,
        geom_type: 'point'
      }
    })
      .then(res => {
        let pointMaterial = new THREE.PointsMaterial({
          size: size,
          color: color,
          sizeAttenuation: false
        })
        res.body.forEach(rec => {
          let pointGeometry = new THREE.Geometry()
          pointGeometry.vertices.push(new THREE.Vector3(rec.x, rec.y, rec.z))
          let point = new THREE.Points(pointGeometry, pointMaterial)
          this.viewer.scene.scene.add(point)
        })
      }, res => {})
  }

  createPolygonLayer (layerName, workpack_id, color, callback) {
    Vue.http.get('/api/layers/data-3d-sample/', {
      params: {
        layer_name: layerName,
        workpack_id: workpack_id,
        geom_type: 'polygon'
      }
    })
      .then(res => {
        let positions = []
        res.body.forEach(wktPoly => {
          let olGeo = wkt.readGeometryFromText(wktPoly.geo)
          let coords = olGeo.getCoordinates()[0]
          for (let i = 0; i < 3; i++) {
            let c = coords[i]
            c.forEach(c1 => positions.push(c1))
          }
        })
        let geometry = new THREE.BufferGeometry()
        geometry.addAttribute('position', new THREE.BufferAttribute(new Float32Array(positions), 3))
        geometry.computeVertexNormals()

        let material = new THREE.MeshLambertMaterial({color: color})
        let mesh = new THREE.Mesh(geometry, material)
        this.viewer.scene.scene.add(mesh)
      }, res => {})
  }


  createCylinderLayer (layerName, color, seamIdent, workpackId) {

   /* var geometry = new THREE.SphereGeometry( 500, 32, 32 )
    geometry.translate(790008.398284696, 7248820.19806785, 0)
    var sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );

    geometry = new THREE.SphereGeometry( 500, 32, 32 )
    geometry.translate(790313.26523942, 7250032.45057451, 0)
    sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );*/



    Vue.http.get('/api/layers/cylinder-layer/', {
      params: {
        layer_name: 'well_drillstrings',
        seam_ident: seamIdent,
        workpack_id: workpackId
      }
    })
      .then(res => {

        let material = new THREE.MeshBasicMaterial( {color: color || 0xffff00, wireframe: true, opacity: 0.7} );

        let group = new THREE.Group()
        group.name = 'drainage_vector'

        // console.log(res.body)

        res.body.forEach(c => {

          // console.log(c)

          let g = new THREE.Geometry();

          for (let i=0; i < c.length; i += 3) {

            g.vertices.push( new THREE.Vector3( c[i], c[i+1], c[i+2] ) );
          }

          for (let i = 0; i < g.vertices.length-1; i+=4) {
            g.faces.push( new THREE.Face3( i, i+1, i+2 ) );
            g.faces.push( new THREE.Face3( i, i+2, i+3 ) );
          }

          g.computeVertexNormals()
          g.computeFaceNormals()

          let plane = new THREE.Mesh(g, material)
          group.add(plane)


        })
        this.viewer.scene.scene.add( group );

        /*var geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(800706.615053016, 7247583.62997754, -644.790751827771)
        var sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );

        geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(800610.520988887, 7247201.52798744, -944.790751828003)
        sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );

        geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(800609.789308195, 7247198.61858142, -794.790751827771)
        sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );*/
      })
  }

  createTmpLayer (layerName, color) {

    /* var geometry = new THREE.SphereGeometry( 500, 32, 32 )
     geometry.translate(790008.398284696, 7248820.19806785, 0)
     var sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
     this.viewer.scene.scene.add( sphere );

     geometry = new THREE.SphereGeometry( 500, 32, 32 )
     geometry.translate(790313.26523942, 7250032.45057451, 0)
     sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
     this.viewer.scene.scene.add( sphere );*/


    let material = new THREE.MeshBasicMaterial( {color: color || 0xffff00, wireframe: true, opacity: 0.7} );
    let c = [[[804532.000002373,7290082.00008243,-15000,804532.000002373,7292482.00008243,-15000,806132.000002373,7292482.00008243,-15000,804532.000002373,7290082.00008243,-15000]],[[806132.000002373,7290082.00008243,-15000,804532.000002373,7290082.00008243,-15000,806132.000002373,7292482.00008243,-15000,806132.000002373,7290082.00008243,-15000]],[[804532.000002373,7292482.00008243,100,806132.000002373,7290082.00008243,100,806132.000002373,7292482.00008243,100,804532.000002373,7292482.00008243,100]],[[804532.000002373,7292482.00008243,100,804532.000002373,7290082.00008243,100,806132.000002373,7290082.00008243,100,804532.000002373,7292482.00008243,100]],[[804532.000002373,7290082.00008243,-15000,804532.000002373,7290082.00008243,100,804532.000002373,7292482.00008243,100,804532.000002373,7290082.00008243,-15000]],[[804532.000002373,7292482.00008243,-15000,804532.000002373,7290082.00008243,-15000,804532.000002373,7292482.00008243,100,804532.000002373,7292482.00008243,-15000]],[[806132.000002373,7290082.00008243,100,806132.000002373,7292482.00008243,-15000,806132.000002373,7292482.00008243,100,806132.000002373,7290082.00008243,100]],[[806132.000002373,7290082.00008243,100,806132.000002373,7290082.00008243,-15000,806132.000002373,7292482.00008243,-15000,806132.000002373,7290082.00008243,100]],[[804532.000002373,7290082.00008243,100,806132.000002373,7290082.00008243,-15000,806132.000002373,7290082.00008243,100,804532.000002373,7290082.00008243,100]],[[804532.000002373,7290082.00008243,100,804532.000002373,7290082.00008243,-15000,806132.000002373,7290082.00008243,-15000,804532.000002373,7290082.00008243,100]],[[804532.000002373,7292482.00008243,-15000,804532.000002373,7292482.00008243,100,806132.000002373,7292482.00008243,100,804532.000002373,7292482.00008243,-15000]],[[806132.000002373,7292482.00008243,-15000,804532.000002373,7292482.00008243,-15000,806132.000002373,7292482.00008243,100,806132.000002373,7292482.00008243,-15000]]];
    // let c = [[[804912.087432939,7291244.00008243,-569.79271452821,804912.087432939,7290849.00008243,-569.79271452821,805921.369140625,7291160.734375,-450,804912.087432939,7291244.00008243,-569.79271452821]],[[804912.087432939,7291244.00008243,-569.79271452821,805921.369140625,7291160.734375,-450,806403.173408963,7291244.00008243,-405.983002090456,804912.087432939,7291244.00008243,-569.79271452821]],[[806403.173408963,7291244.00008243,-405.983002090456,805921.369140625,7291160.734375,-450,806011.517578125,7291050,-450,806403.173408963,7291244.00008243,-405.983002090456]],[[806403.173408963,7291244.00008243,-405.983002090456,806011.517578125,7291050,-450,806050,7290987.3671875,-450,806403.173408963,7291244.00008243,-405.983002090456]],[[806403.173408963,7291244.00008243,-405.983002090456,806050,7290987.3671875,-450,806075.33984375,7290950,-450,806403.173408963,7291244.00008243,-405.983002090456]],[[806403.173408963,7291244.00008243,-405.983002090456,806075.33984375,7290950,-450,806404.340820543,7290849.00008243,-415.818718376144,806403.173408963,7291244.00008243,-405.983002090456]],[[806116.355508381,7290849.00008243,-450,806404.340820543,7290849.00008243,-415.818718376144,806116.166015625,7290850,-450,806116.355508381,7290849.00008243,-450]],[[806116.355508381,7290849.00008243,-450,806116.166015625,7290850,-450,806075.33984375,7290950,-450,806116.355508381,7290849.00008243,-450]],[[806116.355508381,7290849.00008243,-450,806075.33984375,7290950,-450,806050,7290987.3671875,-450,806116.355508381,7290849.00008243,-450]],[[806116.355508381,7290849.00008243,-450,806050,7290987.3671875,-450,804912.087432939,7290849.00008243,-569.79271452821,806116.355508381,7290849.00008243,-450]],[[804912.087432939,7290849.00008243,-569.79271452821,806050,7290987.3671875,-450,806011.517578125,7291050,-450,804912.087432939,7290849.00008243,-569.79271452821]],[[804912.087432939,7290849.00008243,-569.79271452821,806011.517578125,7291050,-450,805921.369140625,7291160.734375,-450,804912.087432939,7290849.00008243,-569.79271452821]],[[806075.33984375,7290950,-450,806116.166015625,7290850,-450,806404.340820543,7290849.00008243,-415.818718376144,806075.33984375,7290950,-450]],[[804912.087432939,7290849.00008243,-569.79271452821,806404.340820543,7290849.00008243,-415.818718376144,806404.730485544,7290849.00008243,-419.10173737465,804912.087432939,7290849.00008243,-569.79271452821]],[[804912.087432939,7290849.00008243,-569.79271452821,806404.730485544,7290849.00008243,-419.10173737465,804912.151981272,7290849.00008243,-570.336549368458,804912.087432939,7290849.00008243,-569.79271452821]],[[806404.340820543,7290849.00008243,-415.818718376144,806403.173408963,7291244.00008243,-405.983002090456,806403.589719335,7291244.00008243,-409.490514584304,806404.340820543,7290849.00008243,-415.818718376144]],[[806404.340820543,7290849.00008243,-415.818718376144,806403.589719335,7291244.00008243,-409.490514584304,806404.730485544,7290849.00008243,-419.10173737465,806404.340820543,7290849.00008243,-415.818718376144]],[[806403.173408963,7291244.00008243,-405.983002090456,804912.087432939,7291244.00008243,-569.79271452821,804912.151981272,7291244.00008243,-570.336549368458,806403.173408963,7291244.00008243,-405.983002090456]],[[806403.173408963,7291244.00008243,-405.983002090456,804912.151981272,7291244.00008243,-570.336549368458,806403.589719335,7291244.00008243,-409.490514584304,806403.173408963,7291244.00008243,-405.983002090456]],[[804912.087432939,7291244.00008243,-569.79271452821,804912.087432939,7290849.00008243,-569.79271452821,804912.151981272,7290849.00008243,-570.336549368458,804912.087432939,7291244.00008243,-569.79271452821]],[[804912.087432939,7291244.00008243,-569.79271452821,804912.151981272,7290849.00008243,-570.336549368458,804912.151981272,7291244.00008243,-570.336549368458,804912.087432939,7291244.00008243,-569.79271452821]],[[804912.151981272,7291244.00008243,-570.336549368458,804912.151981272,7290849.00008243,-570.336549368458,805926.015625,7291187.640625,-450,804912.151981272,7291244.00008243,-570.336549368458]],[[804912.151981272,7291244.00008243,-570.336549368458,805926.015625,7291187.640625,-450,806403.589719335,7291244.00008243,-409.490514584304,804912.151981272,7291244.00008243,-570.336549368458]],[[806403.589719335,7291244.00008243,-409.490514584304,805926.015625,7291187.640625,-450,805950,7291160.609375,-450,806403.589719335,7291244.00008243,-409.490514584304]],[[806403.589719335,7291244.00008243,-409.490514584304,805950,7291160.609375,-450,806000.666015625,7291100.6640625,-450,806403.589719335,7291244.00008243,-409.490514584304]],[[806403.589719335,7291244.00008243,-409.490514584304,806000.666015625,7291100.6640625,-450,806040.35546875,7291050,-450,806403.589719335,7291244.00008243,-409.490514584304]],[[806403.589719335,7291244.00008243,-409.490514584304,806040.35546875,7291050,-450,806106.859375,7290950,-450,806403.589719335,7291244.00008243,-409.490514584304]],[[806403.589719335,7291244.00008243,-409.490514584304,806106.859375,7290950,-450,806404.730485544,7290849.00008243,-419.10173737465,806403.589719335,7291244.00008243,-409.490514584304]],[[806144.405378213,7290849.00008243,-450,806404.730485544,7290849.00008243,-419.10173737465,806144.26953125,7290850,-450,806144.405378213,7290849.00008243,-450]],[[806144.405378213,7290849.00008243,-450,806144.26953125,7290850,-450,806119.57421875,7290919.5703125,-450,806144.405378213,7290849.00008243,-450]],[[806144.405378213,7290849.00008243,-450,806119.57421875,7290919.5703125,-450,806040.35546875,7291050,-450,806144.405378213,7290849.00008243,-450]],[[806144.405378213,7290849.00008243,-450,806040.35546875,7291050,-450,804912.151981272,7290849.00008243,-570.336549368458,806144.405378213,7290849.00008243,-450]],[[804912.151981272,7290849.00008243,-570.336549368458,806040.35546875,7291050,-450,806000.666015625,7291100.6640625,-450,804912.151981272,7290849.00008243,-570.336549368458]],[[804912.151981272,7290849.00008243,-570.336549368458,806000.666015625,7291100.6640625,-450,805950,7291160.609375,-450,804912.151981272,7290849.00008243,-570.336549368458]],[[804912.151981272,7290849.00008243,-570.336549368458,805950,7291160.609375,-450,805926.015625,7291187.640625,-450,804912.151981272,7290849.00008243,-570.336549368458]],[[806040.35546875,7291050,-450,806119.57421875,7290919.5703125,-450,806106.859375,7290950,-450,806040.35546875,7291050,-450]],[[806106.859375,7290950,-450,806119.57421875,7290919.5703125,-450,806404.730485544,7290849.00008243,-419.10173737465,806106.859375,7290950,-450]],[[806404.730485544,7290849.00008243,-419.10173737465,806119.57421875,7290919.5703125,-450,806144.26953125,7290850,-450,806404.730485544,7290849.00008243,-419.10173737465]]];

    let g = new THREE.Geometry();
    c.forEach(s => {
      let arr = s[0]

      for (let i=0; i < 9; i += 3) {
        console.log(arr[i], arr[i+1], arr[i+2])
        g.vertices.push( new THREE.Vector3(arr[i], arr[i+1], arr[i+2]))
      }
    })


    for (let i = 0; i < g.vertices.length-1; i+=3) {
      g.faces.push( new THREE.Face3( i, i+1, i+2 ) );
    }

    g.computeVertexNormals()
    g.computeFaceNormals()

    let plane = new THREE.Mesh(g, material)

    this.viewer.scene.scene.add( plane );

    /*
    * POINT Z (804926.122402976 7291243.00008243 -522.920092448048)
[2019-03-12 07:09:21] [00000] POINT Z (806417.373747018 7291243.00008243 -361.150413908787)
[2019-03-12 07:09:21] [00000] POINT Z (806417.373747018 7291638.00008243 -361.150413908787)
[2019-03-12 07:09:21] [00000] POINT Z (804926.122402976 7291638.00008243 -522.920092448048)
    * */

        /*var geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(804912.087432939, 7290849.00008243, -569.79271452821)
        var sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );

        geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(806404.340820543, 7290849.00008243, -415.818718376144)
        sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );

        geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(806403.173408963, 7291244.00008243, -405.983002090456)
        sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );


        geometry = new THREE.SphereGeometry( 50, 32, 32 )
        geometry.translate(804912.087432939, 7291244.00008243, -569.79271452821)
        sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
        this.viewer.scene.scene.add( sphere );*/


        /*let lines = [[806110.428096372,7290848.00008243,-450,806110.052734375,7290850,-450,806093.296875,7290893.296875,-450,806068.86328125,7290950,-450,806050,7290978.0546875,-450,806023.5390625,7291023.5390625,-450,806006.15234375,7291050,-450,805920.6484375,7291156.328125,-450]];

        lines = lines.concat( [[806428.164685291,7291240.62735768,-475,806376.83984375,7291223.1640625,-475,806350,7291215.9453125,-475,806318.90234375,7291218.90625,-475,806250,7291233.0390625,-475,806233.074066091,7291243.00008243,-475],[806061.63982125,7290848.00008243,-450,806061.1640625,7290850,-450,806029.5625,7290929.5625,-450,806020.04296875,7290950,-450,805994.10546875,7290994.1015625,-450,805950,7291059.0234375,-450,805913.466796875,7291107.4453125,-450]] );

        let materialLine = new THREE.LineBasicMaterial({color: color, linewidth: 4})
        lines.forEach(lineData => {
          let geometryLine = new THREE.BufferGeometry()

          let buffer = new Float32Array(lineData)
          geometryLine.addAttribute('position', new THREE.BufferAttribute(buffer, 3))
          geometryLine.computeBoundingSphere()
          let line = new THREE.Line(geometryLine, materialLine);
          this.viewer.scene.scene.add( line );
        })*/



  }

  createSeamsLayer () {

    Vue.http.get('/api/layers/seams-layer/')
      .then(res => {
        let material = new THREE.MeshBasicMaterial({color: 0xe600ac, wireframe: true, opacity: 0.3, side: THREE.DoubleSide})

        res.body.forEach(c => {



          let b = []

          c.coords.forEach((coord , i) => {
            let g = new THREE.Geometry();
            coord.split(',').slice(0, 4).forEach(p => {
              // b = b.concat(p.split(/\s+/).map(n => parseFloat(n)))
              let pp = p.split(/\s+/).map(n => parseFloat(n))
              g.vertices.push( new THREE.Vector3( pp[0], pp[1], pp[2] ) );
            })



            /*if(!plane.geometry.vertices[i]) {
              return
            }
            plane.geometry.vertices[i].x =  coord[0];
            plane.geometry.vertices[i].y =  coord[1];
            plane.geometry.vertices[i].z =  coord[2];*/

            for (let i = 0; i < g.vertices.length-1; i+=4) {
              g.faces.push( new THREE.Face3( i, i+1, i+2 ) );
              g.faces.push( new THREE.Face3( i, i+2, i+3 ) );
            }

            g.computeVertexNormals()
            g.computeFaceNormals()

            let plane = new THREE.Mesh(g, material)

            this.viewer.scene.scene.add( plane );
          });





          /*console.log(b)
          g.addAttribute('position', new THREE.BufferAttribute(new Float32Array(b), 3))
          g.computeVertexNormals()
          g.computeFaceNormals()*/


        })
      })

    /*var geometry = new THREE.SphereGeometry( 500, 32, 32 )
    geometry.translate(787450, 7203750, -2500)
    var sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );


    geometry = new THREE.SphereGeometry( 500, 32, 32 )
    geometry.translate(787450, 7306150, -2500)
    sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );

    geometry = new THREE.SphereGeometry( 500, 32, 32 )
    geometry.translate(818872.150390625, 7306150, 173.083938598625)
    sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );

    */

  }

  createTestObjects () {
    let geometry = new THREE.SphereGeometry( 50, 32, 32 )
    geometry.translate(806516.777151743, 7288000.00012342, -877.988293876616)
    let sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );

    geometry = new THREE.SphereGeometry( 50, 32, 32 )
    geometry.translate(806516.777151743 + 2000, 7288000.00012342 - 200, 0)
    sphere = new THREE.Mesh( geometry,  new THREE.MeshBasicMaterial( {color: 0xff0000} ) );
    this.viewer.scene.scene.add( sphere );
  }

  destroy () {
    this.workerPool.forEach((worker, i) => {
      worker.terminate()
    })
    this.workerPool = null
    this.viewer = null

    this.textureContainer = null
    this.tilePlaceholders = null
    this.pendingTiles = null
    store.commit('map/loadingTiles', 1)
    this.loadingTiles = null
    this.tilesBuffer = null
    this.seams = null

  }

  redrawTiles () {
    this.tilesBuffer.forEach(t => {
      this.viewer.scene.scene.remove(this.viewer.scene.scene.getObjectByName(t.id + 't'))
      this.viewer.scene.scene.remove(this.viewer.scene.scene.getObjectByName(t.id + 's'))
      delete this.textureContainer[t.id]
    })
    /*this.viewer.scene.scene.children.forEach(c => {
      if (c.name && (c.name[c.name.length-1] === 's' || c.name[c.name.length-1] === 't')) {
        this.viewer.scene.scene.remove(c)
      }
    })*/
    this.tilesBuffer = []
    this.updateTiles()

  }

  removeVectorLayer (vl) {
    this.viewer.scene.scene.children.forEach(c => {
      if (c.name && (c.name === (vl.name + '_vector'))) {

        this.viewer.scene.scene.remove(c)
      }
    })
    vl.enabled = false
  }

  layerExists (name) {
    let f = false
    this.viewer.scene.scene.children.forEach(c => {

      if (c.name && (c.name === (name+ '_vector'))) {
        f = true
      }
    })

    return f
  }

}

export default PotreeService



// WEBPACK FOOTER //
// ./src/service/potreeService.js